import {Brick, registerBrick} from 'olympe';
import React from 'react';
import ReactDOM from 'react-dom';

import {DrawerFiltersContent} from './DrawerFiltersContent.jsx';

/**
 * @typedef {{
 *      allSelected: boolean,
 *      startCreationDate: {selected: string, isInclude: boolean},
 *      endCreationDate: {selected: string, isInclude: boolean},
 *      startRequestedDeliveryDate: {selected: string, isInclude: boolean},
 *      endRequestedDeliveryDate: {selected: string, isInclude: boolean},
 *      categories: {selected: LabelValue[], isInclude: boolean},
 *      companyCode: {selected: LabelValue[], isInclude: boolean},
 *      defaultPlant: {selected: LabelValue[], isInclude: boolean},
 *      defaultStorageLocation: {selected: LabelValue[], isInclude: boolean},
 *      ids: {selected: LabelValue[], isInclude: boolean},
 *      materials: {selected: LabelValue[], isInclude: boolean},
 *      paymentTerms: {selected: LabelValue[], isInclude: boolean},
 *      prNumber: {selected: LabelValue[], isInclude: boolean},
 *      projectTitle: {selected: LabelValue[], isInclude: boolean},
 *      purchaseOrganization: {selected: LabelValue[], isInclude: boolean},
 *      purchasingGroup: {selected: LabelValue[], isInclude: boolean},
 *      requesters: {selected: LabelValue[], isInclude: boolean},
 *      sources: {selected: LabelValue[], isInclude: boolean},
 *      spenders: {selected: LabelValue[], isInclude: boolean},
 *      statuses: {selected: LabelValue[], isInclude: boolean},
 *      supplierStatus: {selected: LabelValue[], isInclude: boolean},
 *      suppliers: {selected: LabelValue[], isInclude: boolean},
 *      wayOfBuying: {selected: LabelValue[], isInclude: boolean},
 * }} Filters
 */

/**
 * This brick renders a filter drawer in Olympe, allowing users to apply and manage advanced filters
 * (e.g., dates, categories, suppliers) for data selection in a dynamic interface. It handles opening, closing,
 * and real-time updates of filter states.
 */
export default class DrawerFilters extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Filters} filters
     * @param {string} currentTab
     * @param {*} getAuthorizationData
     * @param {string} userId
     * @param {*} getFiltersDropdownsOptions
     * @param {function()} forwardEvent
     * @param {function(*)} setFilters
     */
    update($, [filters, currentTab, getAuthorizationData, userId, getFiltersDropdownsOptions], [forwardEvent, setFilters]) {
        // Dialog closing
        const handleClose = () => {
            $.set('open', false);
        };

        // Show/hide the dialog
        $.set('open', true);

        $.observe('open').subscribe((open) => {
            // Rendering
            const elementDom = $.get('elementDom');
            ReactDOM.render((<DrawerFilters.Component
                open={open}
                filters={filters}
                getAuthData={getAuthorizationData}
                forwardEvent={forwardEvent}
                setFilters={setFilters}
                handleClose={handleClose}
                currentTab={currentTab}
                context={$}
                userId={userId}
                getFiltersDropdownsOptions={getFiltersDropdownsOptions}
            />
            ), elementDom);
        });
    }

    /**
     * @protected
     * @param {!BrickContext} $
     */
    init($) {
        // Add a custom div to the body
        const elementDom = document.createElement('div');
        elementDom.setAttribute('id', `show_alert_dialog_${Date.now()}`);
        document.body.appendChild(elementDom);
        $.set('elementDom', elementDom);
        $.set('open', false);
        $.set('value', null);
    }

    /**
     * @protected
     * @param {!BrickContext} $
     */
    destroy($) {
        // Remove the custom div from the body
        const elementDom = $.get('elementDom');
        ReactDOM.unmountComponentAtNode(elementDom);
        document.body.removeChild(elementDom);
    }
}

/**
 * @param {*} props
 * @return {Element}
 * @constructor
 */
DrawerFilters.Component = (props) => {
    return (
        <DrawerFiltersContent {...props} />
    );
};

registerBrick('01804106ed9503fe19d1', DrawerFilters);
